import React from "react";
import styled from "styled-components";
import Icon from "../components/icon";

const StyledErrorMessage = styled.div`
  background-color: #ffe3e2;
  font-size: 1rem;
  padding: 1.5rem 1rem 0.5rem;
`;

const Column1 = styled.div`
  width: 11%;
  display: inline-flex;
`;

const Column2 = styled.div`
  width: 85%;
  display: inline-flex;
  vertical-align: top;
  flex-direction: column;
`;

const Title = styled.div`
  margin-bottom: 10px;
`;

function ErrorMessage({ title, message }) {
  return (
    <StyledErrorMessage>
      <Column1>
        <Icon type="red-alert" size={25} />
      </Column1>
      <Column2>
        {title ? <Title className="bold">{title}</Title> : null}
        <p>{message}</p>
      </Column2>
    </StyledErrorMessage>
  );
}

export default ErrorMessage;
